module.exports = __webpack_public_path__ + "static/media/menu-2.8b4ad3e8.jpg";